<section class="content" id="contentPrint" #contentPrint>
    <header>
        <header-relatorio></header-relatorio>
    </header>
    <main>
        <h2>Relatório de simulação de previdência</h2>
        <table>
            <tbody>
                <tr>
                    <td>Idade Prevista</td>
                    <td class="td-val">{{simulacao.filtro.anoAposentar}} anos
                        <span *ngIf="simulacao.filtro.mesAposentar != 0">
                            e {{simulacao.filtro.mesAposentar}} meses</span>
                    </td>
                </tr>
                <tr>
                    <td>Salário Real de Contribuição</td>
                    <td class="td-val">{{(simulacao.meses[0].src )| currency:'BRL'}}</td>
                </tr>
                <tr>
                    <td>Aporte</td>
                    <td class="td-val">{{simulacao.filtro.aporte | currency:'BRL'}}</td>
                </tr>
                <tr>
                    <td>Contribuição Mensal</td>
                    <td class="td-val">{{(simulacao.meses[0].contribuicaoParticipante / 2) |
                        currency:'BRL'}}</td>
                </tr>
                <tr>
                    <td>Taxas de Juros Anual</td>
                    <td class="td-val">{{simulacao.filtro.taxaJuros | percentage}}</td>
                </tr>
            </tbody>
        </table>
        <h2>Aviso</h2>
        <p>
            A impressão dessa simulação de benefício contempla os dados atuais e também os projetados,
            de acordo com a idade escolhida. A cada mês ocorrerão alteração de valores em decorrência da entrada
            de contribuição e retorno dos investimentos.
        </p>
        <h2>Minha Reserva</h2>
        <table>
            <tbody>
                <tr>
                    <td>Valor Total de Contribuição</td>
                    <td class="td-val">{{ simulacao.contribuicaoTotal | currency:'BRL'}}</td>
                </tr>
                <tr>
                    <td>Total de Rendimentos das Contribuições</td>
                    <td class="td-val">{{(simulacao.rentabilidade) | currency:'BRL'}}</td>
                </tr>
                <tr>
                    <td>Valor Total de Reserva</td>
                    <td class="td-val">{{ simulacao.saldoTotal | currency:'BRL'}}</td>
                </tr>
            </tbody>
        </table>
        <h2>Minhas Contribuições / Beneficio</h2>
        <table>
            <thead>
                <tr>
                    <td>Sequencia</td>
                    <td>Data do Pagamento</td>
                    <td>Contribuição Participante</td>
                    <td>Contribuição Patrocinadora</td>
                    <td>Rentabilidade</td>
                    <td>Beneficio</td>
                    <td>Saldo Final</td>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of simulacao.meses; index as i">
                    <td>{{item.sequencia}}</td>
                    <td>{{item.dataReferencia | date:'dd/MM/yyyy'}}</td>
                    <td>{{(item.contribuicaoParticipante / 2) | currency:'BRL':'symbol':'1.2-2':'pt'}}</td>
                    <td>{{(item.contribuicaoParticipante / 2) | currency:'BRL':'symbol':'1.2-2':'pt'}}</td>
                    <td>{{item.rentabilidade | currency:'BRL':'symbol':'1.2-2':'pt'}}</td>
                    <td>{{item.beneficio | currency:'BRL':'symbol':'1.2-2':'pt'}}</td>
                    <td>{{item.saldoFinal | currency:'BRL':'symbol':'1.2-2':'pt'}}</td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="!simulacao || simulacao.totalProventos >= simulacao.socialSecurityUnit * 2">
            <h2>INFORMAÇÕES</h2>
            <p>
                Caso os valores apresentados ainda não estejam dentro da sua expectativa, existem formas de melhorar
                o
                seu benefício, como contribuir por mais tempo, aumentar sua contribuição extra mensal ou realizar
                aportes.
            </p>
        </div>
        <div *ngIf="simulacao && simulacao.totalProventos < simulacao.socialSecurityUnit * 2">
            <h2>INFORMAÇÕES</h2>
            <p>
                Como o valor mínimo do seu benefício não pode ser abaixo de {{simulacao.socialSecurityUnit * 2 |
                currency:'BRL' }} (valor equivalente a 2 unidades previdenciárias), suas alternativas são contribuir
                por mais tempo,
                aumentar sua contribuição extra mensal ou realizar um aporte para {{simulacao.aporteFaltanteHoje |
                currency:'BRL'}}. Caso não seja possível, será necessário um aporte, na idade de aposentadoria, no
                valor
                de {{simulacao.aporteFaltanteProjetado | currency:'BRL'}}.
            </p>
        </div>
        <br>
        <h2>NOTAS</h2>
        <br>
        <ul>
            <li>O resultado dessa simulação é uma projeção que não se constitui, de modo algum, em garantia,
                proposta ou obrigação por parte da Fundação Copel.</li>
            <li>O valor do saldo projetado foi estimado com base em uma hipótese de rentabilidade que você
                simulou na fase de capitalização, porém, a rentabilidade real dependerá da performance das
                aplicações.</li>
            <li>Para a conversão em renda foi utilizada a hipótese de taxa de juros vigente.</li>
            <li>O valor do aporte apresentado, quando for o caso, representa apenas uma das condições para a
                elegibilidade para o benefício.
                Deverão ser verificadas as demais condições de elegibilidade como idade e tempo de filiação.
            </li>
            <li>Os valores simulados podem ter variação de acordo com o motivo do desligamento. Havendo
                dúvidas favor entrar em contato com nossa Central de Atendimento</li>
        </ul>
    </main>
    <br>
    <footer>
        <footer-relatorio></footer-relatorio>
    </footer>
</section>